import axios from "axios";
import state from "../store";


const getBabyDetails = (id) => axios.get(state.getters.mainAppURL + `baby_names/${id}`);
const updateBabyDetails = (babyDetails) => axios.put(state.getters.mainAppURL + `baby_names`, babyDetails);

const getCustomerBabies = (requestParams) => axios.post(
    `${state.getters.mainAppURL}baby_names/customer_details`, requestParams, );

const getCustomerDetails = (id) => axios.get(state.getters.mainAppURL + `baby_names/customer_details/${id}`);

export {
    getBabyDetails,
    updateBabyDetails,
    getCustomerBabies,
    getCustomerDetails
}